module.exports = __webpack_public_path__ + "static/media/vi_th.9172c93b.png";